import {
  getProductList
} from '@/api/product/select' 
import {
  getProductById
} from '@/api/product/select'
import {
  addProduct
} from '@/api/product/add' 
import {
  updateProduct
} from '@/api/product/update' 
import {
  updateProductReleaseKbn
} from '@/api/product/update'
import {
  deleteProduct
} from '@/api/product/delete'

import {
  getProductType
} from '@/api/product/select' //引入产品类型 api 接口
import {
  getProductsAndTypes
} from '@/api/product/select' //引入产品类型 api 接口
import {
  AddProductType
} from '@/api/product/add' //引入新闻列表 api 接口

import {
  UpdateProductType
} from '@/api/product/update' //引入新闻列表 api 接口

import {
  deleteType
} from '@/api/product/delete' //引入新闻列表 api 接口

const apiInterfaceProduct = {
  actions: {
    // 获取产品类型
    GetProductTypes({
      commit
    } ) { //定义 GetProductTypes 方法，在组件中使用 this.$store.dispatch("GetProductTypes") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        getProductType().then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

  //添加产品类型
  AddType ({
    commit
  }, pType) { //定义 GetProductTypes 方法，在组件中使用 this.$store.dispatch("GetProductTypes") 调用
    return new Promise((resolve, reject) => { //封装一个 Promise
      AddProductType(pType).then(response => {
        commit('') //提交一个 mutation，通知状态改变
        resolve(response) //将结果封装进 Promise
      }).catch(error => {
        reject(error)
      })
    })
  },

  //修改产品类型
  UpdateType ({
    commit
  }, pType) { //定义 GetProductTypes 方法，在组件中使用 this.$store.dispatch("GetProductTypes") 调用
    return new Promise((resolve, reject) => { //封装一个 Promise
      UpdateProductType(pType).then(response => {
        commit('') //提交一个 mutation，通知状态改变
        resolve(response) //将结果封装进 Promise
      }).catch(error => {
        reject(error)
      })
    })
  },

  //删除类型
  Deletetypeinfo ({
    commit
  }, jo) {
    return new Promise((resolve, reject) => { //封装一个 Promise
      deleteType(jo).then(response => { //使用 login 接口进行网络请求
        commit('') //提交一个 mutation，通知状态改变   
        resolve(response) //将结果封装进 Promise
      }).catch(error => {
        reject(error)
      })
    })
  },


    // 获取产品
    GetProducts({
      commit
    } ) { //定义 GetProducts 方法，在组件中使用 this.$store.dispatch("GetProducts") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        getProductList().then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 分类型获取产品
    GetProductsAndTypes({
      commit
    } ) { //定义 GetProducts 方法，在组件中使用 this.$store.dispatch("GetProducts") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        getProductsAndTypes().then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetProductById({
      commit
    },productId ) { //定义 GetProducts 方法，在组件中使用 this.$store.dispatch("GetProducts") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        getProductById(productId).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    //添加产品
    AddProduct({
      commit
    }, product) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        addProduct(product).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateProduct({
      commit
    }, product) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        updateProduct(product).then(response => { 
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateProductReleaseKbn({
      commit
    }, product) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        updateProductReleaseKbn(product.productId,product.releaseKbn,product.updateTime).then(response => { 
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    DeleteProduct({
      commit
    }, productIds) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        deleteProduct(productIds).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}
export default apiInterfaceProduct